/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import type {PageStrings} from '../types/rules-types'

export type AppPayloadWithStrings = {page_strings?: PageStrings}

export const useRuleStrings = () =>
  useAppPayload<AppPayloadWithStrings>()?.page_strings ?? {
    heading: 'Rulesets',
    alphaOrBeta: '',
    headingText: "You haven't created any rulesets",
    rulesetOrPolicy: 'ruleset',
    rulesetsOrPolicies: 'rulesets',
    ruleOrPolicy: 'rule',
    rulesOrPolicies: 'rules',
    upsellHeaderText: 'Protect your most important branches',
    upsellInfoMessage:
      'whether collaborators can delete or force push and set requirements for any pushes, such as passing status checks or a linear commit history.',
  }
